import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { 
  Sparkles, 
  Star, 
  Heart, 
  Calculator, 
  Calendar, 
  Shield, 
  Gem, 
  Clock,
  Compass,
  Moon,
  Sun
} from 'lucide-react';

const freeTools = [
  {
    name: 'Free Kundli',
    description: 'Generate birth chart',
    href: '/kundli',
    icon: Sparkles,
    color: 'from-amber-500 to-orange-500',
    bgColor: 'bg-amber-50',
  },
  {
    name: 'Horoscope',
    description: 'Daily predictions',
    href: '/horoscope',
    icon: Star,
    color: 'from-purple-500 to-indigo-500',
    bgColor: 'bg-purple-50',
  },
  {
    name: 'Matchmaking',
    description: 'Kundli Milan',
    href: '/matchmaking',
    icon: Heart,
    color: 'from-pink-500 to-rose-500',
    bgColor: 'bg-pink-50',
  },
  {
    name: 'Panchang',
    description: 'Auspicious timings',
    href: '/panchang',
    icon: Calendar,
    color: 'from-green-500 to-emerald-500',
    bgColor: 'bg-green-50',
  },
  {
    name: 'Numerology',
    description: 'Lucky numbers',
    href: '/numerology',
    icon: Calculator,
    color: 'from-blue-500 to-cyan-500',
    bgColor: 'bg-blue-50',
  },
  {
    name: 'Tarot Reading',
    description: 'Card guidance',
    href: '/tarot',
    icon: Moon,
    color: 'from-violet-500 to-purple-500',
    bgColor: 'bg-violet-50',
  },
  {
    name: 'Love Calculator',
    description: 'Compatibility check',
    href: '/love-calculator',
    icon: Heart,
    color: 'from-red-500 to-pink-500',
    bgColor: 'bg-red-50',
  },
  {
    name: 'Dosha Analysis',
    description: 'Manglik & more',
    href: '/dosha',
    icon: Shield,
    color: 'from-orange-500 to-red-500',
    bgColor: 'bg-orange-50',
  },
  {
    name: 'Gem Suggestion',
    description: 'Lucky stones',
    href: '/gem-recommendation',
    icon: Gem,
    color: 'from-teal-500 to-cyan-500',
    bgColor: 'bg-teal-50',
  },
  {
    name: 'Dasha',
    description: 'Planetary periods',
    href: '/dasha',
    icon: Clock,
    color: 'from-indigo-500 to-blue-500',
    bgColor: 'bg-indigo-50',
  },
  {
    name: 'Vastu Compass',
    description: '16 zones guide',
    href: '/vastu-compass',
    icon: Compass,
    color: 'from-emerald-500 to-green-500',
    bgColor: 'bg-emerald-50',
  },
];

export const FreeToolsBar = () => {
  return (
    <section className="bg-gradient-to-r from-amber-50 via-white to-amber-50 py-4 border-b border-amber-100" data-testid="free-tools-bar">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="flex items-center justify-center gap-2 mb-3">
          <Sun className="w-5 h-5 text-amber-500" />
          <h3 className="text-sm font-semibold text-foreground">
            100% Free Astrology Tools
          </h3>
          <Sun className="w-5 h-5 text-amber-500" />
        </div>
        
        {/* Tools Grid - Scrollable on mobile */}
        <div className="overflow-x-auto scrollbar-thin scrollbar-thumb-amber-200 scrollbar-track-transparent pb-2">
          <div className="flex justify-start lg:justify-center gap-3 min-w-max">
            {freeTools.map((tool, index) => (
              <motion.div
                key={tool.name}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.05 }}
              >
                <Link
                  to={tool.href}
                  className={`flex items-center gap-2 px-3 py-2 rounded-full ${tool.bgColor} hover:shadow-md transition-all duration-300 group border border-transparent hover:border-amber-200`}
                  data-testid={`tool-${tool.name.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  <div className={`w-8 h-8 rounded-full bg-gradient-to-br ${tool.color} flex items-center justify-center shadow-sm group-hover:scale-110 transition-transform`}>
                    <tool.icon className="w-4 h-4 text-white" />
                  </div>
                  <div className="pr-1">
                    <p className="text-xs font-semibold text-foreground whitespace-nowrap">
                      {tool.name}
                    </p>
                    <p className="text-[10px] text-muted-foreground whitespace-nowrap">
                      {tool.description}
                    </p>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FreeToolsBar;
